import request from "superagent";
import { getErrorMessage } from "../../utils/errors";
import { getAuthHeader } from "../../utils/superagent";
import { isDefined } from "@clipboard-health/util-ts";
const handleError = (error) => ({
  body: {
    error: getErrorMessage(error),
  },
});

export const getUpcomingShiftsGrouped = async (workplaceId?: string) => {
  const queryParams = isDefined(workplaceId) ? { workplaceId } : {};
  return request
    .get(`${global.api}/v1/shifts/upcomingShiftsGrouped`)
    .set(await getAuthHeader())
    .query(queryParams)
    .then(({ body }) => body.response)
    .catch(handleError);
};
